import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
Vue.use(Router)
// 解决路由重复点击报异常问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  routes: [
    {
      path: '/Home',
      name: 'Home',
      component: () => import(/* webpackChunkName: "Home" */ "../views/Home.vue"),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/',
      name: 'Home',
      component: () => import(/* webpackChunkName: "Home" */ "../views/Home.vue"),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: "/Login",
      redirect: "/",
    },
    {
      path: "/register",
      name: "register",
      component: () => import(/* webpackChunkName: "register" */ "../views/register.vue"),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: "/forget",
      name: "forget",
      component: () => import(/* webpackChunkName: "forget" */ "../views/forget.vue"),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: "/otherPage",
      name: "otherPage",
      component: () => import(/* webpackChunkName: "forget" */ "../views/other/otherPage.vue"),
      meta: {
        keepAlive: false // 不需要缓存
      },
      children: [
        {
          path: "/orderDocument",
          name: "orderDocument",
          component: () => import(/* webpackChunkName: "orderDocument" */ "../views/other/orderDocument.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/Operations",
          name: "Operations",
          component: () => import(/* webpackChunkName: "Operations" */ "../views/other/Operations.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/contactWay",
          name: "contactWay",
          component: () => import(/* webpackChunkName: "contactWay" */ "../views/other/contactWay.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
      ],
    },
    {
      path: "/minePage",
      name: "minePage",
      component: () => import(/* webpackChunkName: "forget" */ "../views/mine/minePage.vue"),
      meta: {
        keepAlive: false // 不需要缓存
      },
      children: [
        {
          path: "/manegeCenter",
          name: "manegeCenter",
          component: () => import(/* webpackChunkName: "manegeCenter" */ "../views/mine/manegeCenter.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/orderManege",
          name: "orderManege",
          component: () => import(/* webpackChunkName: "orderManege" */ "../views/mine/orderManege.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/orderDetail",
          name: "orderDetail",
          component: () => import(/* webpackChunkName: "orderDetail" */ "../views/mine/orderDetail.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/application_after",
          name: "application_after",
          component: () => import(/* webpackChunkName: "application_after" */ "../views/mine/application_after.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/financeDetails",
          name: "financeDetails",
          component: () => import(/* webpackChunkName: "financeDetails" */ "../views/mine/financeDetails.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/personalInfo",
          name: "personalInfo",
          component: () => import(/* webpackChunkName: "personalInfo" */ "../views/mine/personalInfo.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/authentication",
          name: "authentication",
          component: () => import(/* webpackChunkName: "authentication" */ "../views/mine/authentication.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/invoiceTitle",
          name: "invoiceTitle",
          component: () => import(/* webpackChunkName: "invoiceTitle" */ "../views/mine/invoiceTitle.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/InvoiceManagement",
          name: "InvoiceManagement",
          component: () => import(/* webpackChunkName: "InvoiceManagement" */ "../views/mine/InvoiceManagement.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/modifyPass",
          name: "modifyPass",
          component: () => import(/* webpackChunkName: "modifyPass" */ "../views/mine/modifyPass.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/prestorage",
          name: "prestorage",
          component: () => import(/* webpackChunkName: "prestorage" */ "../views/mine/prestorage.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/after_sales_reasons",
          name: "after_sales_reasons",
          component: () => import(/* webpackChunkName: "after_sales_reasons" */ "../views/mine/after_sales_reasons.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/couponList",
          name: "couponList",
          component: () => import(/* webpackChunkName: "couponList" */ "../views/mine/couponList.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: "/myCoupon",
          name: "myCoupon",
          component: () => import(/* webpackChunkName: "myCoupon" */ "../views/mine/myCoupon.vue"),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
      ],
    },
    {
      path: "/orderPage",
      name: "orderPage",
      component: () => import(/* webpackChunkName: "orderPage" */ "../views/order/orderPage.vue"),
      meta: {
        keepAlive: false // 不需要缓存
      },
    }
  ],
})
router.beforeEach((to, from, next) => {
  const needAuth =
    to.path === '/orderPage' ||
    to.matched.some((record) => record.path === '/minePage')
  if (needAuth && !localStorage.getItem('yinyi_token')) {
    next('/')
  } else {
    next()
  }
})
export default router
